export const merchantId = "1438";
export const API_KEY = "1438chgw-f6f5cfd463dedeeb55be5b91ed54cbb5";
export const hostUrl = "https://stage-api.pinch.ai";
export const demoStoreUrl = "https://api-demostore.pinch.ai";
